import { render, staticRenderFns } from "./BookingBlockDialog.vue?vue&type=template&id=770a5846"
import script from "./BookingBlockDialog.vue?vue&type=script&lang=js"
export * from "./BookingBlockDialog.vue?vue&type=script&lang=js"
import style0 from "./BookingBlockDialog.vue?vue&type=style&index=0&id=770a5846&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports